// File: src/data/facultiesData.js
// Description: Faculty data with real lecturer names and information

import { LANGUAGES } from '../context/LanguageContext';

export const facultiesData = {
  pariyatti: {
    id: 'pariyatti',
    name: {
      [LANGUAGES.EN]: 'Faculty of Pariyatti',
      [LANGUAGES.MM]: 'ပရိယတ္တိမဟာဌာန'
    },
    description: {
      [LANGUAGES.EN]: 'The Faculty of Pariyatti focuses on the theoretical study of Buddhist scriptures and teachings.',
      [LANGUAGES.MM]: 'ပရိယတ္တိမဟာဌာနသည် ဗုဒ္ဓဘာသာကျမ်းဂန်များနှင့် သွန်သင်ချက်များကို သီအိုရီအရ လေ့လာသည့် မဟာဌာနဖြစ်သည်။'
    },
    dean: {
      name: {
        [LANGUAGES.EN]: 'Dr. Ashin Ñāṇuttara',
        [LANGUAGES.MM]: 'ဒေါက်တာ အရှင်ဉာဏုတ္တရ'
      },
      photo: '/images/faculties/pariyatti/dean.jpg'
    },
    lecturers: [
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Vāyama',
          [LANGUAGES.MM]: 'ဒေါက်တာဝါယမ'
        },
        title: {
          [LANGUAGES.EN]: 'Archivist',
          [LANGUAGES.MM]: 'မော်ကွန်းထိန်း'
        },
        photo: '/images/faculties/pariyatti/lecturer1.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Ashin Āciṇṇa',
          [LANGUAGES.MM]: 'ဒေါက်တာအရှင်အာစိဏ္ဏ'
        },
        title: {
          [LANGUAGES.EN]: 'Sri Lanka',
          [LANGUAGES.MM]: 'သိရီလင်္ကာ'
        },
        photo: '/images/faculties/pariyatti/lecturer2.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Ghosita',
          [LANGUAGES.MM]: 'အရှင်ဃောသိတ'
        },
        photo: '/images/faculties/pariyatti/lecturer3.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Paṇḍitālaṅkāra',
          [LANGUAGES.MM]: 'အရှင်ပဏ္ဍိတာလင်္ကာရ'
        },
        photo: '/images/faculties/pariyatti/lecturer4.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Ashin Varañāṇa',
          [LANGUAGES.MM]: 'ဒေါက်တာအရှင်ဝရဉာဏ'
        },
        title: {
          [LANGUAGES.EN]: 'Archivist',
          [LANGUAGES.MM]: 'မော်ကွန်းထိန်း'
        },
        photo: '/images/faculties/pariyatti/lecturer5.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Sobhanajoti',
          [LANGUAGES.MM]: 'အရှင်သောဘနဇောတိ'
        },
        photo: '/images/faculties/pariyatti/lecturer6.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Candimā',
          [LANGUAGES.MM]: 'အရှင်စန္ဒိမာ'
        },
        photo: '/images/faculties/pariyatti/lecturer7.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Kulavaṁsa',
          [LANGUAGES.MM]: 'အရှင်ကုလဝံသ'
        },
        photo: '/images/faculties/pariyatti/lecturer8.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Jotisaddhammāpāla',
          [LANGUAGES.MM]: 'အရှင်ဇောတိသဒ္ဓမ္မပါလ'
        },
        photo: '/images/faculties/pariyatti/lecturer9.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Puññāsāra',
          [LANGUAGES.MM]: 'အရှင်ပုညာစာရ'
        },
        photo: '/images/faculties/pariyatti/lecturer10.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Nandasīri',
          [LANGUAGES.MM]: 'အရှင်နန္ဒသိရီ'
        },
        photo: '/images/faculties/pariyatti/lecturer11.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Vijayālaṅkāra',
          [LANGUAGES.MM]: 'အရှင်ဝိဇယာလင်္ကာရ'
        },
        photo: '/images/faculties/pariyatti/lecturer12.jpg'
      }
    ],
    departments: {
      vinaya: {
        name: {
          [LANGUAGES.EN]: 'Vinaya Department',
          [LANGUAGES.MM]: 'ဝိနယဌာန'
        },
        subjects: [
          { code: 'PRYT-101', name: { [LANGUAGES.EN]: 'Introduction to Vinaya Piṭaka', [LANGUAGES.MM]: 'ဝိနယပိဋကတ် မိတ်ဆက်' }},
          { code: 'PRYT-111', name: { [LANGUAGES.EN]: 'Introduction to Vinaya Piṭaka', [LANGUAGES.MM]: 'ဝိနယပိဋကတ် မိတ်ဆက်' }},
          { code: 'PRYT-1001', name: { [LANGUAGES.EN]: 'Selected study of Vinaya', [LANGUAGES.MM]: 'ဝိနယ ရွေးချယ်လေ့လာမှု' }},
          { code: 'ဝိနယ-1001', name: { [LANGUAGES.EN]: 'Vinaya (Parajika Pali Text) (1)', [LANGUAGES.MM]: 'ဝိနယ (ပါရာဇီကဏ်ပါဠိတော်) (၁)' }},
          { code: 'ဝိနယ-1002', name: { [LANGUAGES.EN]: 'Vinaya (Parajika Pali Text) (2)', [LANGUAGES.MM]: 'ဝိနယ (ပါရာဇီကဏ်ပါဠိတော်) (၂)' }}
        ]
      },
      abhidhamma: {
        name: {
          [LANGUAGES.EN]: 'Abhidhamma Department',
          [LANGUAGES.MM]: 'အဘိဓမ္မာဌာန'
        },
        subjects: [
          { code: 'PRYT-103', name: { [LANGUAGES.EN]: 'Introduction to Abhidhamma Piṭaka', [LANGUAGES.MM]: 'အဘိဓမ္မာပိဋကတ် မိတ်ဆက်' }},
          { code: 'PRYT-113', name: { [LANGUAGES.EN]: 'Introduction to Abhidhamma Piṭaka', [LANGUAGES.MM]: 'အဘိဓမ္မာပိဋကတ် မိတ်ဆက်' }},
          { code: 'PRYT-1003', name: { [LANGUAGES.EN]: 'Selected study of Abhidhamma', [LANGUAGES.MM]: 'အဘိဓမ္မာ ရွေးချယ်လေ့လာမှု' }},
          { code: 'အဘိဓမ္မာ-1001', name: { [LANGUAGES.EN]: 'Dhammasangani Pali Text (1)', [LANGUAGES.MM]: 'ဓမ္မသင်္ဂဏီပါဠိတော် (၁)' }},
          { code: 'အဘိဓမ္မာ-1002', name: { [LANGUAGES.EN]: 'Dhammasangani Pali Text (2)', [LANGUAGES.MM]: 'ဓမ္မသင်္ဂဏီပါဠိတော် (၂)' }}
        ]
      },
      suttanta: {
        name: {
          [LANGUAGES.EN]: 'Suttanta Department',
          [LANGUAGES.MM]: 'သုတ္တန္တဌာန'
        },
        subjects: [
          { code: 'PRYT-102', name: { [LANGUAGES.EN]: 'Introduction to Suttanta Piṭaka', [LANGUAGES.MM]: 'သုတ္တန္တပိဋကတ် မိတ်ဆက်' }},
          { code: 'PRYT-112', name: { [LANGUAGES.EN]: 'Introduction to Suttanta Piṭaka', [LANGUAGES.MM]: 'သုတ္တန္တပိဋကတ် မိတ်ဆက်' }},
          { code: 'PRYT-1002', name: { [LANGUAGES.EN]: 'Selected study of Suttanta', [LANGUAGES.MM]: 'သုတ္တန္တ ရွေးချယ်လေ့လာမှု' }},
          { code: 'သုတန္တ-1001', name: { [LANGUAGES.EN]: 'Silakkhandha Pali Text (1)', [LANGUAGES.MM]: 'သီလက္ခန်ပါဠိတော် (၁)' }},
          { code: 'သုတန္တ-1002', name: { [LANGUAGES.EN]: 'Silakkhandha Pali Text (2)', [LANGUAGES.MM]: 'သီလက္ခန်ပါဠိတော် (၂)' }}
        ]
      }
    }
  },
  patipatti: {
    id: 'patipatti',
    name: {
      [LANGUAGES.EN]: 'Faculty of Patipatti',
      [LANGUAGES.MM]: 'ပဋိပတ္တိမဟာဌာန'
    },
    description: {
      [LANGUAGES.EN]: 'The Faculty of Patipatti focuses on the practical aspects of Buddhist meditation and spiritual practice.',
      [LANGUAGES.MM]: 'ပဋိပတ္တိမဟာဌာနသည် ဗုဒ္ဓဘာသာ တရားထိုင်ခြင်းနှင့် ဝိညာဏ်ရေးရာ လက်တွေ့ကျင့်စဉ်များကို အဓိကထားသည်။'
    },
    dean: {
      name: {
        [LANGUAGES.EN]: 'Dr. Ashin Varañāṇa',
        [LANGUAGES.MM]: 'ဒေါက်တာအရှင်ဝရဉာဏ'
      },
      photo: '/images/faculties/patipatti/dean.jpg'
    },
    lecturers: [
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Ashin Āsiñña',
          [LANGUAGES.MM]: 'ဒေါက်တာအရှင်အာစိဏ္ဏ'
        },
        photo: '/images/faculties/patipatti/lecturer1.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Ashin Jotika',
          [LANGUAGES.MM]: 'ဒေါက်တာအရှင်ဇောတိက'
        },
        title: {
          [LANGUAGES.EN]: 'Theravāda',
          [LANGUAGES.MM]: 'ထေရဝါဒ'
        },
        photo: '/images/faculties/patipatti/lecturer2.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Revata',
          [LANGUAGES.MM]: 'အရှင်ရေဝတ'
        },
        title: {
          [LANGUAGES.EN]: 'Theravāda',
          [LANGUAGES.MM]: 'ထေရဝါဒ'
        },
        photo: '/images/faculties/patipatti/lecturer3.jpg'
      }
    ],
    departments: {
      samatha: {
        name: {
          [LANGUAGES.EN]: 'Samatha Department',
          [LANGUAGES.MM]: 'သမထဌာန'
        },
        subjects: [
          { code: 'PTPT-101', name: { [LANGUAGES.EN]: 'Paṭipatti (Samatha)', [LANGUAGES.MM]: 'ပဋိပတ္တိ (သမထ)' }},
          { code: 'PTPT-111', name: { [LANGUAGES.EN]: 'Paṭipatti (Samatha)', [LANGUAGES.MM]: 'ပဋိပတ္တိ (သမထ)' }},
          { code: 'PTPT-1001', name: { [LANGUAGES.EN]: 'Practical aspect of Samatha', [LANGUAGES.MM]: 'သမထ လက်တွေ့ကျင့်စဉ်' }},
          { code: 'PTPT-1011', name: { [LANGUAGES.EN]: 'Practical aspect of Samatha', [LANGUAGES.MM]: 'သမထ လက်တွေ့ကျင့်စဉ်' }},
          { code: 'PTPT-2001', name: { [LANGUAGES.EN]: 'Practical aspect of Samatha', [LANGUAGES.MM]: 'သမထ လက်တွေ့ကျင့်စဉ်' }}
        ]
      },
      vipassana: {
        name: {
          [LANGUAGES.EN]: 'Vipassana Department',
          [LANGUAGES.MM]: 'ဝိပဿနာဌာန'
        },
        subjects: [
          { code: 'PTPT-102', name: { [LANGUAGES.EN]: 'Paṭipatti (Vipassanā)', [LANGUAGES.MM]: 'ပဋိပတ္တိ (ဝိပဿနာ)' }},
          { code: 'PTPT-112', name: { [LANGUAGES.EN]: 'Paṭipatti (Vipassanā)', [LANGUAGES.MM]: 'ပဋိပတ္တိ (ဝိပဿနာ)' }},
          { code: 'PTPT-1002', name: { [LANGUAGES.EN]: 'Practical aspect of Vipassanā', [LANGUAGES.MM]: 'ဝိပဿနာ လက်တွေ့ကျင့်စဉ်' }},
          { code: 'PTPT-1012', name: { [LANGUAGES.EN]: 'Practical aspect of Vipassanā', [LANGUAGES.MM]: 'ဝိပဿနာ လက်တွေ့ကျင့်စဉ်' }},
          { code: 'PTPT-2002', name: { [LANGUAGES.EN]: 'Practical aspect of Vipassanā', [LANGUAGES.MM]: 'ဝိပဿနာ လက်တွေ့ကျင့်စဉ်' }}
        ]
      }
    }
  },
  language: {
    id: 'language',
    name: {
      [LANGUAGES.EN]: 'Faculty of Language Studies',
      [LANGUAGES.MM]: 'ဘာသာစကားလေ့လာရေးမဟာဌာန'
    },
    description: {
      [LANGUAGES.EN]: 'The Faculty of Language Studies offers comprehensive language education including Myanmar, English, Pali, Sanskrit, and Hindi.',
      [LANGUAGES.MM]: 'ဘာသာစကားလေ့လာရေးမဟာဌာနသည် မြန်မာ၊ အင်္ဂလိပ်၊ ပါဠိ၊ သက္ကတနှင့် ဟိန္ဒီဘာသာများကို ပြည့်စုံစွာ သင်ကြားပေးသည်။'
    },
    dean: {
      name: {
        [LANGUAGES.EN]: 'Dr. Ashin Ketu',
        [LANGUAGES.MM]: 'ဒေါက်တာအရှင်ကေတု'
      },
      photo: '/images/faculties/language/dean.jpg'
    },
    lecturers: [
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Ashin Kelāsa',
          [LANGUAGES.MM]: 'ဒေါက်တာအရှင်ကေလာသ'
        },
        title: {
          [LANGUAGES.EN]: 'Thadhu',
          [LANGUAGES.MM]: 'သာဓု'
        },
        photo: '/images/faculties/language/lecturer1.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Kavidhaja',
          [LANGUAGES.MM]: 'အရှင်ကဝိဓဇ'
        },
        photo: '/images/faculties/language/lecturer2.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Ashin Paṇḍita',
          [LANGUAGES.MM]: 'ဒေါက်တာအရှင်ပဏ္ဍိတ'
        },
        photo: '/images/faculties/language/lecturer3.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Ñāṇadhaja',
          [LANGUAGES.MM]: 'အရှင်ဉာဏဓဇ'
        },
        photo: '/images/faculties/language/lecturer4.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Ashin Paññāvaṁsa',
          [LANGUAGES.MM]: 'ဒေါက်တာအရှင်ပညာဝံသ'
        },
        photo: '/images/faculties/language/lecturer5.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Ñāṇavudha',
          [LANGUAGES.MM]: 'အရှင်ဉာဏာဝုဓ'
        },
        photo: '/images/faculties/language/lecturer6.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Ñāṇasīri',
          [LANGUAGES.MM]: 'အရှင်ဉာဏသိရီ'
        },
        photo: '/images/faculties/language/lecturer7.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Candimā',
          [LANGUAGES.MM]: 'အရှင်စန္ဒိမာ'
        },
        photo: '/images/faculties/language/lecturer8.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Ādicca',
          [LANGUAGES.MM]: 'အရှင်အာဒိစ္စ'
        },
        photo: '/images/faculties/language/lecturer9.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Jotika',
          [LANGUAGES.MM]: 'အရှင်ဇောတိက'
        },
        title: {
          [LANGUAGES.EN]: 'Shwe Kyin',
          [LANGUAGES.MM]: 'ရွှေကျင်'
        },
        photo: '/images/faculties/language/lecturer10.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Jotika',
          [LANGUAGES.MM]: 'အရှင်ဇောတိက'
        },
        title: {
          [LANGUAGES.EN]: 'Nyaung Lay Pin',
          [LANGUAGES.MM]: 'ညောင်လေးပင်'
        },
        photo: '/images/faculties/language/lecturer11.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Candāvara',
          [LANGUAGES.MM]: 'အရှင်စန္ဒာ၀ရ'
        },
        photo: '/images/faculties/language/lecturer12.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Indañāṇa',
          [LANGUAGES.MM]: 'အရှင်ဣန္ဒဉာဏ'
        },
        photo: '/images/faculties/language/lecturer13.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Paññābala',
          [LANGUAGES.MM]: 'အရှင်ပညာဗလ'
        },
        photo: '/images/faculties/language/lecturer14.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Ñāṇiṭṭhāra Laṅkāra',
          [LANGUAGES.MM]: 'အရှင်ဉာဏိဿရာလင်္ကာရ'
        },
        photo: '/images/faculties/language/lecturer15.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Ñāṇavaṁsa',
          [LANGUAGES.MM]: 'အရှင်ဉာဏဝံသ'
        },
        photo: '/images/faculties/language/lecturer16.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Ashin Ravinda',
          [LANGUAGES.MM]: 'အရှင်ရဝိန္ဒ'
        },
        photo: '/images/faculties/language/lecturer17.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'U Kyaw Hlaing',
          [LANGUAGES.MM]: 'ဦးကျော်လှိုင်'
        },
        photo: '/images/faculties/language/lecturer18.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'U Maung Win',
          [LANGUAGES.MM]: 'ဦးမောင်ဝင်း'
        },
        title: {
          [LANGUAGES.EN]: 'Pāli Guru',
          [LANGUAGES.MM]: 'ပါဠိဂုရု'
        },
        photo: '/images/faculties/language/lecturer19.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'U Kaung Myat Thu',
          [LANGUAGES.MM]: 'ဦးကောင်းမြတ်သူ'
        },
        photo: '/images/faculties/language/lecturer20.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Hla Htun',
          [LANGUAGES.MM]: 'ဒေါက်တာလှထွန်း'
        },
        photo: '/images/faculties/language/lecturer21.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'U Bo Bo Win',
          [LANGUAGES.MM]: 'ဦးဘိုဘိုဝင်း'
        },
        photo: '/images/faculties/language/lecturer22.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'U Nyan Zaw',
          [LANGUAGES.MM]: 'ဦးဥာဏ်ဇော်'
        },
        photo: '/images/faculties/language/lecturer23.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'U Thura Kyaw',
          [LANGUAGES.MM]: 'ဦးသူရကျော်'
        },
        photo: '/images/faculties/language/lecturer24.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'U Maung Maung Win',
          [LANGUAGES.MM]: 'ဦးမောင်မောင်ဝင်း'
        },
        photo: '/images/faculties/language/lecturer25.jpg'
      }
    ],
    departments: {
      myanmar: {
        name: {
          [LANGUAGES.EN]: 'Myanmar Language Department',
          [LANGUAGES.MM]: 'မြန်မာစာဌာန'
        },
        subjects: [
          { code: 'မြန်မာ-1001', name: { [LANGUAGES.EN]: 'Myanmar Language (1)', [LANGUAGES.MM]: 'မြန်မာစာ (၁)' }},
          { code: 'မြန်မာ-1002', name: { [LANGUAGES.EN]: 'Myanmar Language (2)', [LANGUAGES.MM]: 'မြန်မာစာ (၂)' }}
        ]
      },
      english: {
        name: {
          [LANGUAGES.EN]: 'English Language Department',
          [LANGUAGES.MM]: 'အင်္ဂလိပ်စာဌာန'
        },
        subjects: [
          { code: 'ENG-011', name: { [LANGUAGES.EN]: 'General English', [LANGUAGES.MM]: 'ယေဘုယျ အင်္ဂလိပ်စာ' }},
          { code: 'ENG-022', name: { [LANGUAGES.EN]: 'Buddhistic English', [LANGUAGES.MM]: 'ဗုဒ္ဓဘာသာ အင်္ဂလိပ်စာ' }},
          { code: 'ENG-101', name: { [LANGUAGES.EN]: 'English', [LANGUAGES.MM]: 'အင်္ဂလိပ်စာ' }},
          { code: 'ENG-111', name: { [LANGUAGES.EN]: 'English I', [LANGUAGES.MM]: 'အင်္ဂလိပ်စာ ၁' }},
          { code: 'အင်္ဂလိပ်-101', name: { [LANGUAGES.EN]: 'English Language', [LANGUAGES.MM]: 'အင်္ဂလိပ်စာ' }}
        ]
      },
      pali: {
        name: {
          [LANGUAGES.EN]: 'Pali Language Department',
          [LANGUAGES.MM]: 'ပါဠိဘာသာဌာန'
        },
        subjects: [
          { code: 'PALI-101', name: { [LANGUAGES.EN]: 'Pāḷi Grammar', [LANGUAGES.MM]: 'ပါဠိသဒ္ဒါ' }},
          { code: 'PALI-111', name: { [LANGUAGES.EN]: 'Pāḷi Grammar', [LANGUAGES.MM]: 'ပါဠိသဒ္ဒါ' }},
          { code: 'PALI-1001', name: { [LANGUAGES.EN]: 'Pāḷi Grammar', [LANGUAGES.MM]: 'ပါဠိသဒ္ဒါ' }},
          { code: 'ပါဠိ-111', name: { [LANGUAGES.EN]: 'Pali', [LANGUAGES.MM]: 'ပါဠိ' }},
          { code: 'ပါဠိ-1001', name: { [LANGUAGES.EN]: 'Pali (Selected Text)', [LANGUAGES.MM]: 'ပါဠိ (သရုပ်ခွဲတော်)' }}
        ]
      },
      sanskrit: {
        name: {
          [LANGUAGES.EN]: 'Sanskrit Language Department',
          [LANGUAGES.MM]: 'သက္ကတဘာသာဌာန'
        },
        subjects: [
          { code: 'သက္ကတ-111', name: { [LANGUAGES.EN]: 'Sanskrit Grammar', [LANGUAGES.MM]: 'သက္ကတသဒ္ဒါ' }},
          { code: 'သက္ကတ-211', name: { [LANGUAGES.EN]: 'Sanskrit Grammar', [LANGUAGES.MM]: 'သက္ကတသဒ္ဒါ' }},
          { code: 'သက္ကတ-1001', name: { [LANGUAGES.EN]: 'Sanskrit Grammar', [LANGUAGES.MM]: 'သက္ကတသဒ္ဒါ' }},
          { code: 'သက္ကတ-112', name: { [LANGUAGES.EN]: 'Sanskrit Literature', [LANGUAGES.MM]: 'သက္ကတသာဓု' }},
          { code: 'သက္ကတ-212', name: { [LANGUAGES.EN]: 'Sanskrit Literature', [LANGUAGES.MM]: 'သက္ကတသာဓု' }}
        ]
      },
      hindi: {
        name: {
          [LANGUAGES.EN]: 'Hindi Language Department',
          [LANGUAGES.MM]: 'ဟိန္ဒီဘာသာဌာန'
        },
        subjects: [
          { code: 'HINDI-101', name: { [LANGUAGES.EN]: 'Hindi Language', [LANGUAGES.MM]: 'ဟိန္ဒီဘာသာ' }},
          { code: 'HINDI-111', name: { [LANGUAGES.EN]: 'Hindi Language', [LANGUAGES.MM]: 'ဟိန္ဒီဘာသာ' }}
        ]
      }
    }
  },
  social: {
    id: 'social',
    name: {
      [LANGUAGES.EN]: 'Faculty of Social Science',
      [LANGUAGES.MM]: 'လူမှုရေးသိပ္ပံမဟာဌာန'
    },
    description: {
      [LANGUAGES.EN]: 'The Faculty of Social Science covers Buddhist philosophy, history, and geography with focus on Eastern and Western perspectives.',
      [LANGUAGES.MM]: 'လူမှုရေးသိပ္ပံမဟာဌာနသည် ဗုဒ္ဓဘာသာ ဒဿနိကရေး၊ သမိုင်းနှင့် ပထဝီဝင်ကို အရှေ့နှင့်အနောက် ရှုထောင့်များဖြင့် လေ့လာသည်။'
    },
    dean: {
      name: {
        [LANGUAGES.EN]: 'Dr. Zin Htun Tint',
        [LANGUAGES.MM]: 'ဒေါက်တာဇင်ထွန်းတင့်'
      },
      photo: '/images/faculties/social/dean.jpg'
    },
    lecturers: [
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Aye Myint',
          [LANGUAGES.MM]: 'ဒေါက်တာအေးမြင့်'
        },
        photo: '/images/faculties/social/lecturer1.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Dr. San Htun',
          [LANGUAGES.MM]: 'ဒေါက်တာဆန်းထွန်း'
        },
        photo: '/images/faculties/social/lecturer2.jpg'
      }
    ],
    departments: {
      philosophy: {
        name: {
          [LANGUAGES.EN]: 'Philosophy Department',
          [LANGUAGES.MM]: 'ဒဿနိကရေးဌာန'
        },
        subjects: [
          { code: 'PHIL-1001', name: { [LANGUAGES.EN]: 'Elementary Logic (Deduction)', [LANGUAGES.MM]: 'အခြေခံ ယုတ္တိဗေဒ (နိဂုံးချုပ်ခြင်း)' }},
          { code: 'PHIL-1011', name: { [LANGUAGES.EN]: 'Elementary Logic (Induction)', [LANGUAGES.MM]: 'အခြေခံ ယုတ္တိဗေဒ (စုစည်းခြင်း)' }},
          { code: 'PHIL-2001', name: { [LANGUAGES.EN]: 'Western Philosophy', [LANGUAGES.MM]: 'အနောက်တိုင်း ဒဿနိကရေး' }},
          { code: 'PHIL-2011', name: { [LANGUAGES.EN]: 'Eastern Philosophy', [LANGUAGES.MM]: 'အရှေ့တိုင်း ဒဿနိကရေး' }},
          { code: 'ဒဿနိက-114', name: { [LANGUAGES.EN]: 'Ancient Indian Philosophy', [LANGUAGES.MM]: 'ရှေးခေတ် အိန္ဒိယ ဒဿနိကရေး' }}
        ]
      },
      history: {
        name: {
          [LANGUAGES.EN]: 'Buddhist History Department',
          [LANGUAGES.MM]: 'ဗုဒ္ဓသာသနိကဝင်သမိုင်းဌာန'
        },
        subjects: [
          { code: 'HIST-101', name: { [LANGUAGES.EN]: 'Buddhist History', [LANGUAGES.MM]: 'ဗုဒ္ဓသာသနာ သမိုင်း' }},
          { code: 'HIST-111', name: { [LANGUAGES.EN]: 'Buddhist History', [LANGUAGES.MM]: 'ဗုဒ္ဓသာသနာ သမိုင်း' }},
          { code: 'HIST-1001', name: { [LANGUAGES.EN]: 'Buddhist History', [LANGUAGES.MM]: 'ဗုဒ္ဓသာသနာ သမိုင်း' }},
          { code: 'သမိုင်း-115', name: { [LANGUAGES.EN]: 'Ancient Indian History', [LANGUAGES.MM]: 'ရှေးခေတ် အိန္ဒိယသမိုင်း' }},
          { code: 'သမိုင်း-215', name: { [LANGUAGES.EN]: 'Ancient Indian History', [LANGUAGES.MM]: 'ရှေးခေတ် အိန္ဒိယသမိုင်း' }}
        ]
      },
      geography: {
        name: {
          [LANGUAGES.EN]: 'Buddhist Geography Department',
          [LANGUAGES.MM]: 'ဗုဒ္ဓသာသနိကဝင်ပထဝီဝင်ဌာန'
        },
        subjects: [
          { code: 'ပထဝီ-111', name: { [LANGUAGES.EN]: 'Indian Geography', [LANGUAGES.MM]: 'အိန္ဒိယ ပထဝီဝင်' }},
          { code: 'ပထဝီ-211', name: { [LANGUAGES.EN]: 'Indian Geography', [LANGUAGES.MM]: 'အိန္ဒိယ ပထဝီဝင်' }},
          { code: 'ပထဝီ-1001', name: { [LANGUAGES.EN]: 'Buddhist Geography', [LANGUAGES.MM]: 'ဗုဒ္ဓသာသနိက ပထဝီဝင်' }},
          { code: 'ပထဝီ-1002', name: { [LANGUAGES.EN]: 'Buddhist Geography', [LANGUAGES.MM]: 'ဗုဒ္ဓသာသနိက ပထဝီဝင်' }}
        ]
      }
    }
  },
  missionary: {
    id: 'missionary',
    name: {
      [LANGUAGES.EN]: 'Faculty of Missionary and World Religions',
      [LANGUAGES.MM]: 'သာသနာပြုနှင့် ကမ္ဘာ့သာသနာကြီးများလေ့လာမှုမဟာဌာန'
    },
    description: {
      [LANGUAGES.EN]: 'The Faculty of Missionary and World Religions focuses on Buddhist missionary work and comparative study of world religions.',
      [LANGUAGES.MM]: 'သာသနာပြုနှင့် ကမ္ဘာ့သာသနာကြီးများလေ့လာမှုမဟာဌာနသည် ဗုဒ္ဓဘာသာ သာသနာပြုလုပ်ငန်းနှင့် ကမ္ဘာ့သာသနာများကို နှိုင်းယှဉ်လေ့လာခြင်းကို အဓိကထားသည်။'
    },
    dean: {
      name: {
        [LANGUAGES.EN]: 'Dr. Ashin Ottama',
        [LANGUAGES.MM]: 'ဒေါက်တာအရှင်ဥတ္တမ'
      },
      photo: '/images/faculties/missionary/dean.jpg'
    },
    lecturers: [
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Ashin Thura',
          [LANGUAGES.MM]: 'ဒေါက်တာအရှင်သူရ'
        },
        photo: '/images/faculties/missionary/lecturer1.jpg'
      },
      {
        name: {
          [LANGUAGES.EN]: 'Dr. Ashin Nyana',
          [LANGUAGES.MM]: 'ဒေါက်တာအရှင်ဉာဏ'
        },
        photo: '/images/faculties/missionary/lecturer2.jpg'
      }
    ],
    departments: {
      missionary: {
        name: {
          [LANGUAGES.EN]: 'Missionary Department',
          [LANGUAGES.MM]: 'သာသနာပြုဌာန'
        },
        subjects: [
          { code: 'MISN-111', name: { [LANGUAGES.EN]: 'Missionary Works', [LANGUAGES.MM]: 'သာသနာပြုလုပ်ငန်း' }},
          { code: 'MISN-101', name: { [LANGUAGES.EN]: 'Missionary Works', [LANGUAGES.MM]: 'သာသနာပြုလုပ်ငန်း' }},
          { code: 'MISN-1001', name: { [LANGUAGES.EN]: 'Missionary Works', [LANGUAGES.MM]: 'သာသနာပြုလုပ်ငန်း' }},
          { code: 'MISN-1011', name: { [LANGUAGES.EN]: 'Missionary Works', [LANGUAGES.MM]: 'သာသနာပြုလုပ်ငန်း' }},
          { code: 'သာသနာပြု-1001', name: { [LANGUAGES.EN]: 'Missionary Activities (1)', [LANGUAGES.MM]: 'သာသနာပြုလုပ်ငန်း (၁)' }},
          { code: 'သာသနာပြု-1002', name: { [LANGUAGES.EN]: 'Missionary Activities (2)', [LANGUAGES.MM]: 'သာသနာပြုလုပ်ငန်း (၂)' }}
        ]
      },
      worldReligions: {
        name: {
          [LANGUAGES.EN]: 'World Religions Department',
          [LANGUAGES.MM]: 'ကမ္ဘာ့သာသနာကြီးများဌာန'
        },
        subjects: [
          { code: 'WR-1001', name: { [LANGUAGES.EN]: 'Comparative Religion Studies', [LANGUAGES.MM]: 'သာသနာနှိုင်းယှဉ်လေ့လာမှု' }},
          { code: 'WR-1002', name: { [LANGUAGES.EN]: 'World Religions Overview', [LANGUAGES.MM]: 'ကမ္ဘာ့သာသနာများ ခြုံငုံသုံးသပ်ချက်' }},
          { code: 'WR-2001', name: { [LANGUAGES.EN]: 'Christianity and Buddhism', [LANGUAGES.MM]: 'ခရစ်ယာန်နှင့် ဗုဒ္ဓဘာသာ' }},
          { code: 'WR-2002', name: { [LANGUAGES.EN]: 'Islam and Buddhism', [LANGUAGES.MM]: 'အစ္စလာမ်နှင့် ဗုဒ္ဓဘာသာ' }}
        ]
      }
    }
  }
};

// Faculty statistics
export const facultyStats = {
  totalFaculties: Object.keys(facultiesData).length,
  totalLecturers: Object.values(facultiesData).reduce((total, faculty) => total + faculty.lecturers.length, 0),
  totalDepartments: Object.values(facultiesData).reduce((total, faculty) => total + Object.keys(faculty.departments).length, 0),
  totalSubjects: Object.values(facultiesData).reduce((total, faculty) => 
    total + Object.values(faculty.departments).reduce((deptTotal, dept) => deptTotal + dept.subjects.length, 0), 0)
};

// Helper functions
export const getFacultyById = (id) => {
  return facultiesData[id];
};

export const getFacultiesByDepartment = (departmentName, language = LANGUAGES.EN) => {
  return Object.values(facultiesData).filter(faculty => 
    Object.values(faculty.departments).some(dept => 
      dept.name[language] && dept.name[language].toLowerCase().includes(departmentName.toLowerCase())
    )
  );
};

export const searchFaculties = (searchTerm, language = LANGUAGES.EN) => {
  const term = searchTerm.toLowerCase();
  return Object.values(facultiesData).filter(faculty => 
    faculty.name[language].toLowerCase().includes(term) ||
    faculty.description[language].toLowerCase().includes(term) ||
    faculty.dean.name[language].toLowerCase().includes(term) ||
    faculty.lecturers.some(lecturer => 
      lecturer.name[language].toLowerCase().includes(term)
    ) ||
    Object.values(faculty.departments).some(dept => 
      dept.name[language].toLowerCase().includes(term) ||
      dept.subjects.some(subject => 
        subject.name[language].toLowerCase().includes(term)
      )
    )
  );
};

export const getFacultyNames = (language = LANGUAGES.EN) => {
  return Object.values(facultiesData).map(faculty => ({
    id: faculty.id,
    name: faculty.name[language]
  }));
};

export const getLecturersByFaculty = (facultyId) => {
  const faculty = getFacultyById(facultyId);
  return faculty ? faculty.lecturers : [];
};

export const getDepartmentsByFaculty = (facultyId, language = LANGUAGES.EN) => {
  const faculty = getFacultyById(facultyId);
  return faculty ? Object.values(faculty.departments).map(dept => dept.name[language]) : [];
};

export const getSubjectsByFaculty = (facultyId, language = LANGUAGES.EN) => {
  const faculty = getFacultyById(facultyId);
  if (!faculty) return [];
  
  return Object.values(faculty.departments).reduce((allSubjects, dept) => {
    const subjects = dept.subjects.map(subject => subject.name[language]);
    return [...allSubjects, ...subjects];
  }, []);
};

export default facultiesData;